// extracted by mini-css-extract-plugin
export var locationCard = "_hx-0";